import * as actions from '../actions/SearchAndRetrieve'

const initialState = {
  error: '',
  loading: false,
  cancelPackageSuccess: false,
  deliveryMethods: [],
  searchResults: [],
  packagePDF: []
}

const SearchAndRetrieveReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SEARCH_PACKAGES_LOADER:
      return {
        ...state,
        loading: action.loading
      }
    case actions.CLEAR_SEARCH_RESULTS:
      return {
        ...state,
        searchResults: action.results
      }
    case actions.GET_PACKAGES:
      return {
        ...state,
        searchResults: action.packages
      }
    case actions.GET_PACKAGES_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.GET_DELIVERY_METHODS:
      return {
        ...state,
        deliveryMethods: action.deliveryMethods
      }
    case actions.GET_DELIVERY_METHODS_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.CANCEL_PACKAGE_SUCCESS:
      return {
        ...state,
        cancelPackageSuccess: action.cancelPackageSuccess
      }
    case actions.CANCEL_PACKAGE_ERROR:
      return {
        ...state,
        error: action.error
      }
    case actions.GET_PACKAGE_PDF_ERROR:
      return {
        ...state,
        error: action.error
      }
    default:
      return state
  }
}

export default SearchAndRetrieveReducer
